import { Menu } from 'antd'
import React from 'react'
import { Route } from 'react-router-dom'
import BidOffer from './BidOffer'
import ScheduleDetail from './ScheduleDetail'
import PJMUnitInfo from './PJMUnitExtension'
import VerificationPnodeInfo from './VerificationPnode'
import CausecodeWatchlist from './CausecodeAlertlist'
import PJMUnitTransferInfo from './PJMUnitTransfer'
import InstalledCapClaimed from './InstalledCapClaimed'
import VerificationLockInfo from './VerificationLock'
import VerificationMWH from './VerificationHourlyMWVerification'
import RealTimeLMP from './RealTimeLMP'
import PeakDefinition from './PeakDefinition'
import OaHoliday from './OaHoliday'

const PjmAdminMenu = ({ onSelect, theme, selectedKeys }) => {
  return (
    <Menu
      mode="vertical"
      onSelect={onSelect}
      theme={theme}
      selectedKeys={selectedKeys}
    >
      <Menu.SubMenu title="PJM Configuration">
        {/* <Menu.Item key="verification-lock">Verification Lock</Menu.Item> */}
        <Menu.Item key="pjm-unit">PJM Unit Extension</Menu.Item>
        <Menu.Item key="pjm-unit-transfer">Dynamic Unit Transfer</Menu.Item>
        <Menu.Item key="causecode-watchlist">Causecode Watch List</Menu.Item>
        <Menu.Item key="installed-capacity">Installed Capacity</Menu.Item>
        <Menu.Item key="verification-pnode">Verification Pnode</Menu.Item>
        <Menu.Item key="verification-mwh-import">
          Verification Hourly MWH Import
        </Menu.Item>
        <Menu.Item key="pjm-holiday">PJM Holiday Management</Menu.Item>
      </Menu.SubMenu>
    </Menu>
  )
}

const PjmAdminOutageMenu = ({ onSelect, theme, selectedKeys }) => {
  return (
    <Menu
      mode="vertical"
      onSelect={onSelect}
      theme={theme}
      selectedKeys={selectedKeys}
    >
      <Menu.SubMenu key="Outage-analysis-admin" title="Outage Analysis">
        <Menu.Item key="pjm-rtlmp">Real Time LMP</Menu.Item>
        <Menu.Item key="bid-offer-admin">Bid Offer</Menu.Item>
        <Menu.Item key="schedule-details-admin">Schedule Details</Menu.Item>
        <Menu.Item key="peakdefinition">Peak Definition</Menu.Item>
      </Menu.SubMenu>
    </Menu>
  )
}

// eslint-disable-next-line no-unused-vars
const PjmAdminRouteContainer = ({ actionPermits, envConfig }) => {
  return (
    <React.Fragment>
      <Route exact path="/peakdefinition" component={PeakDefinition} />
      <Route exact path="/bid-offer-admin" component={BidOffer} />
      <Route exact path="/schedule-details-admin" component={ScheduleDetail} />
      <Route exact path="/pjm-unit" component={PJMUnitInfo} />
      <Route
        exact
        path="/verification-pnode"
        component={VerificationPnodeInfo}
      />
      <Route exact path="/causecode-watchlist" component={CausecodeWatchlist} />
      <Route exact path="/pjm-unit-transfer" component={PJMUnitTransferInfo} />
      <Route exact path="/installed-capacity" component={InstalledCapClaimed} />
      <Route exact path="/verification-lock" component={VerificationLockInfo} />
      <Route
        exact
        path="/verification-mwh-import"
        component={VerificationMWH}
      />
      <Route exact path="/pjm-rtlmp" component={RealTimeLMP} />
      <Route exact path="/pjm-holiday" component={OaHoliday} />
    </React.Fragment>
  )
}

export { PjmAdminMenu, PjmAdminRouteContainer, PjmAdminOutageMenu }
